import { v4 as uuid } from "uuid";
import ProspectAPI from "@/api/ProspectAPI";
import { createSlice, current, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import {PROSPECT} from "@/actions/globalConst";
import { useParams, useNavigate, useLocation, Navigate } from "react-router-dom";
import CalenderHelperClass from '@/helpers/CalenderHelper'
import moment from 'moment';


let initialState = {
    selected: false,
    item: null,
    items: [],
    view: PROSPECT.VIEW_OVERVIEW,
    apiState: PROSPECT.API_INIT,
    key: "",
    error: null,
    needToUpdate: true
};


const rejectEventHandler=((state, action) => {
    state.error = action.payload;
    state.key = uuid().slice(0, 8);
});
const pendingEventHandler=((state, action) => {
    state.apiState = PROSPECT.API_PROCESSING;
})
let fullFilledEventHandler= ( (state, action) => {
        if(action.payload.data.state == 9) {
            let events = current(state.items)[action.payload.data.from];
            events = CalenderHelperClass.removeEvent([...events], action.payload.data);
            if(events.length == 0) {
                delete state.items[action.payload.data.from];
            } else {
                state.items[action.payload.data.from] = events;
            }
            state.apiState = PROSPECT.API_REFRESH;
         }
    
    if(action.payload.data.item) {
        state.item = action.payload.data.item;
        if(action.payload.data.state == 1) {
            let events = current(state.items)[action.payload.data.from];
            if(!events) {
                events = [];                
            }
            events = CalenderHelperClass.removeEvent([...events], state.item);
            if(events.length == 0) {
                delete state.items[action.payload.data.from];
            } else {
                state.items[action.payload.data.from] = events;
            }
            events = current(state.items)[state.item.dayKey];
            if(!events) {
                events = [];                
            }
            events = CalenderHelperClass.addEvent([...events], state.item);
            if(events.length == 0) {
                delete state.items[state.item.dayKey];
            } else {
                state.items[state.item.dayKey] = events;
            }
            state.apiState = PROSPECT.API_REFRESH;
            
            
        }
        if(action.payload.data.state == 0) {
            let events = state.items[state.item.dayKey];
            if(events) {
                events.push(state.item);
                state.items[state.item.dayKey] = events;
            } else {
                state.items[state.item.dayKey] = [state.item];
            }
            state.apiState = PROSPECT.API_REFRESH;
        }
    }
    if(action.payload.data.users) {
        state.users = action.payload.data.users;
    }
    if(action.payload.data.selected) {
        state.selected = action.payload.data.selected;
    }
    if(action.payload.data.items) {
        state.items = action.payload.data.items;
    }
    if(action.payload.data.schedule) {
        state.schedule = action.payload.data.schedule;
        //localStorage.setItem("refreshView", 'calender');
    }
    if(action.payload.data.priority) {
        state.priority = action.payload.data.priority;
        //localStorage.setItem("refreshView", 'calender');
    }
    if(action.payload.data.event_types) {
        state.event_types = action.payload.data.event_types;
        //localStorage.setItem("refreshView", 'calender');
    }

    state.view = PROSPECT.CREATE_TASK;
    
    if(action.type == "com_api_save/fulfilled" || action.type == "com_api_delete/fulfilled" || action.type == "GET_TASKS/fulfilled") {
        state.apiState = PROSPECT.API_REFRESH;
    } else {
      state.apiState = PROSPECT.API_READY;  
    }
    //;
    state.key = uuid().slice(0, 8);
    state.error = null;
    return state;
})



/*
let newDossier = localStorage.getItem("newDossier");
if(newDossier) {
    if(window.location.pathname == '/dossiers/new') {
    newDossier = JSON.parse(newDossier);
    initialState.selected = newDossier;
    initialState.apiState = DOSSIER.API_READY;
    initialState.view = DOSSIER.VIEW_NEW;
    } else {
        localStorage.removeItem("newDossier");
    }
}
*/
let task = null;
const ProspectReducer = createSlice({
  name: 'Prospect',
  initialState,
  reducers: {
       checkItem(state, action) {
           state.dragOverElement = action.payload;
           if(action.payload && action.payload?.withCheck === true) {
                CalenderHelperClass.checkIs(action.payload, current(state.dragItem), current(state.items));
           }
           return state;
           },
       setSelectedUsers(state, action = null) {
           state.selectedUsers = action.payload;
           },
       getState(state, action = null) {
           return current(state)
           },
       setSelectedDate(state, action) {
           state.selectedDate = action.payload;
           },
       setDragItem(state, action) {
           state.dragItem = action.payload;
           },
       setUpdate(state, action) {
           state.needToUpdate = action.payload;
           },
       setChangedItems(state, action) {
           if(action.payload.item && action.payload.index >= 0) {
               state.items[action.payload.index] = action.payload.item;
           }
               state.needToUpdate = true;
        }
        ,
       storeCalenderSettings(state, action) {
               state.calenderSettings = {...state.calenderSettings, ...action.payload};
               localStorage.setItem("calender_settings", JSON.stringify(state.calenderSettings));
        }
        
    // omit existing reducers here
  },
  extraReducers(builder) {

    task = getProspects;
    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandler(state, action)).addCase(task.rejected, (state, action) => rejectEventHandler(state, action)).addCase(task.pending, (state, action) => pendingEventHandler(state, action));


    builder.addMatcher(
      (action) => action.type == "switchtenant/pending",
      (state, action) => {

        state.items = null;
        state.selectedDate = moment();
        state.selectedUsers = [];
        state.users = [];
        state.item = null;
          
       })

    
//    task = getTasks;
//    builder.addCase(task.fulfilled, ((state, action) => {return fullFilledEventHandler(state, action)})).addCase(task.rejected, ((state, action) => reject)).addCase(task.pending, ((state, action) => pending));
/*
    task = getTasks;
    builder.addCase(task.fulfilled, (state, action) => {
        fullFilledEventHandler(state, action);
        return;
    
    if(action.payload.data.item) {
        state.item = action.payload.data.item;
    }
    if(action.payload.data.selected) {
        state.selected = action.payload.data.selected;
    }
    if(action.payload.data.items) {
        state.items = action.payload.data.items;
    }
    state.view = PROSPECT.CREATE_TASK;
    state.apiState = PROSPECT.API_READY;
    state.key = uuid().slice(0, 8);
    state.error = null;
    }).addCase(getTasks.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(getTasks.pending, (state, action) => {
        state.apiState = PROSPECT.API_PROCESSING;
    });
*/    
  }
  })


export const getProspects = createAsyncThunk(PROSPECT.GET_TASKS, async (data:any= null, event) => {
    let response = null;
    try {
          response = await ProspectAPI.get(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

  
/*
export const dossierStore = createAsyncThunk(DOSSIER.ACTION_STORE, async (data, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await DossierAPI.index();
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)
*/

export const { setChangedItems, storeCalenderSettings, setUpdate, setDragItem, checkItem,setSelectedDate, getState, setSelectedUsers} = ProspectReducer.actions;
export default ProspectReducer.reducer